import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getAccountSettings} from 'src/openapi/admin/apis/GetAccountSettingsApi';
import {saveAccountSettings} from 'src/openapi/admin/apis/SaveAccountSettingsApi';
import {AccreditationStatus} from 'src/openapi/admin/models/AccreditationStatus';
import {useAppDispatch} from 'src/store/hooks';

import type {AccountSettings} from 'src/openapi/admin/models/AccountSettings';

type Props = {
    accountId: number,
};

export const useAccountSettings = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getAccountSettings({accountId}),
    ), [accountId, apiDispatch]);

    const saveDispatchAction = useCallback((accountSettings: AccountSettings) => apiDispatch(
        saveAccountSettings({accountId, accountSettings}),
    ), [accountId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: {
            untracked: false,
            projectCodesEnabled: false,
            projectCodesRequired: false,
            businessLinesCode: [],
            screenRecording: false,
            liveChatEnabled: false,
            sfCommunitiesEnabled: false,
            pbPioneer: false,
            accreditationStatus: AccreditationStatus.ACCREDITED,
        },
    });
};
